var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user
    ? _c("div", { class: { "my-4 compose": !_vm.compact } }, [
        _c("div", { staticClass: "card", class: { "border-0": _vm.compact } }, [
          _c(
            "form",
            {
              staticClass: "card-body",
              class: { "p-0": _vm.compact },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  _vm.submit($event)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "form-group relative" },
                [
                  _c("rich-textarea", {
                    ref: "textarea",
                    staticClass: "form-control textarea",
                    attrs: { disabled: !!_vm.ppromise },
                    on: {
                      "update:compiledText": _vm.updateCompiledText,
                      "update:compiledTextCount": _vm.updateCompiledTextLength,
                      submit: _vm.submit
                    },
                    model: {
                      value: _vm.rawText,
                      callback: function($$v) {
                        _vm.rawText = $$v
                      },
                      expression: "rawText"
                    }
                  }),
                  _c(
                    "a",
                    {
                      staticClass: "open-emoji-picker text-dark",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.toggleEmojiPalette($event)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-lg fa-smile-o" })]
                  ),
                  _vm.mounted
                    ? _c("picker", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showEmojiPicker,
                            expression: "showEmojiPicker"
                          },
                          {
                            name: "on-click-outside",
                            rawName: "v-on-click-outside",
                            value: _vm.closeEmojiPalette,
                            expression: "closeEmojiPalette"
                          }
                        ],
                        staticClass: "emoji-picker",
                        attrs: { set: "emojione" },
                        on: { click: _vm.addEmoji }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.photos.length,
                      expression: "photos.length"
                    }
                  ],
                  staticClass: "form-group"
                },
                [
                  _c(
                    "transition-group",
                    {
                      staticClass:
                        "d-flex flex-wrap justify-cotnent align-items-center",
                      attrs: { tag: "div", name: "photos" }
                    },
                    _vm._l(_vm.previewPhotos, function(photo, i) {
                      return _c("thumb", {
                        key: photo.data,
                        staticClass: "mr-2",
                        attrs: {
                          original: photo.data,
                          thumb: photo.data,
                          removable: ""
                        },
                        on: {
                          remove: function($event) {
                            _vm.photos.splice(i, 1)
                          }
                        }
                      })
                    })
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.videos.length,
                      expression: "videos.length"
                    }
                  ],
                  staticClass: "form-group"
                },
                [
                  _c(
                    "transition-group",
                    {
                      staticClass:
                        "d-flex flex-wrap justify-cotnent align-items-center",
                      attrs: { tag: "div", name: "videos" }
                    },
                    _vm._l(_vm.previewVideos, function(video, i) {
                      return _c("vthumb", {
                        key: video.data,
                        staticClass: "mr-2",
                        attrs: {
                          original: video.data,
                          thumb: video.data,
                          removable: ""
                        },
                        on: {
                          remove: function($event) {
                            _vm.videos.splice(i, 1)
                          }
                        }
                      })
                    })
                  )
                ],
                1
              ),
              _vm.error
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-danger fade show",
                      attrs: { role: "alert" }
                    },
                    [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center"
                },
                [
                  _c("strong", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.postCounter))
                  ]),
                  _c("div", [
                    _vm.$store.state.user.storage
                      ? _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.noPhoto,
                                expression: "!noPhoto"
                              }
                            ],
                            staticClass: "btn btn-link text-muted add-photo",
                            attrs: { disabled: _vm.ppromise }
                          },
                          [
                            _c("i", { staticClass: "fa fa-picture-o" }),
                            _vm._v("  Add photo…\n              "),
                            _c("input", {
                              ref: "file",
                              staticStyle: { display: "none" },
                              attrs: {
                                type: "file",
                                multiple: "",
                                accept: "image/*"
                              },
                              on: { change: _vm.filePhotoChange }
                            })
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "button",
                      {
                        staticClass: "btn text-uppercase",
                        class:
                          "btn-" + (_vm.disabled ? "secondary" : "primary"),
                        attrs: { type: "submit", disabled: _vm.disabled }
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ppromise,
                                expression: "ppromise"
                              }
                            ]
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-refresh fa-spin fa-fw"
                            }),
                            _vm._v(" \n              ")
                          ]
                        ),
                        _vm._v("\n              Post\n            ")
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ac39df2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac39df2","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/Compose.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7ac39df2","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/Compose.vue
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13